import angular from 'angular';

angular
  .module('cloudX')
  .controller('SimilarRelationDialogCtrl', [
    'resourceFactorySvc',
    '$element',
    'flySvc',
    'close',
    'similarRelations',
    SimilarRelationDialogCtrl,
  ]);

function SimilarRelationDialogCtrl(resourceFactorySvc, $element, flySvc, close, similarRelations) {
  var vm = this;
  vm.saving = false;

  vm.relations = similarRelations;

  vm.undelete = function(rel) {
    if (vm.saving) return;
    vm.saving = true;
    resourceFactorySvc.get('relation').undelete(
      {
        id: rel.id,
      },
      function() {
        $element.modal('hide');
        rel.isActive = true;
        vm.saving = false;
        close(rel, 500);
      },
      function(error) {
        if (error?.data?.code === 2021) {
          //Already active
          $element.modal('hide');
          rel.isActive = true;
          vm.saving = false;
          close(rel, 500);
          return;
        }
        flySvc.error(error);
        vm.saving = false;
      },
    );
  };

  vm.select = function(rel) {
    close(rel, 500);
  };
  vm.continue = function() {
    close(false, 500);
  };
  vm.cancel = function() {
    close(null, 500);
  };
}
